import React from 'react';
import { styles } from './BannerBadge.css';
import { RedFlag } from './RedFlag/RedFlag';
import { Starburst } from './Starburst/Starburst';
import { getPriceText, getHotDealHalfPriceText, getSubText } from './utils';

export type BannerBadgeProps = {
  badgeStyle?: 'Red flag' | 'Star burst';
  badge?: '$ off' | '% off' | '1/2 price' | 'While stocks last!' | 'Hot price!' | 'Hot deal!';
  displayPrice: number;
  saveAmount: number;
  wasPrice: number;
  displayWasPrice?: boolean;
  variant: 'small' | 'large' | 'mobile';
  endDate?: string;
};

export const BannerBadge = ({
  badgeStyle = 'Red flag',
  badge,
  saveAmount,
  wasPrice,
  displayWasPrice,
  variant,
  endDate,
  displayPrice,
}: BannerBadgeProps) => {
  const isRedFlag = badgeStyle === 'Red flag';
  const isHalfPrice = badge === '1/2 price';
  const isWhileStocksLast = badge === 'While stocks last!';
  const hasPriceOrPercent = ['$ off', '% off'].includes(badge ?? '');
  const pricePercentNumber = getPriceText(badge, saveAmount, wasPrice);
  const shouldShowPriceBadge = !!(displayWasPrice && hasPriceOrPercent && pricePercentNumber !== undefined);
  const discountPercent = (wasPrice - displayPrice) / wasPrice;
  const isMoreThanHalfPrice = discountPercent >= 0.5;
  const isLongPrice =
    badge === '$ off' && !Number.isInteger(saveAmount) && saveAmount.toString().replace('.', '').length >= 4;
  const subText = getSubText(badge);
  const hotDealHalfPriceText = getHotDealHalfPriceText(badge);

  const badgeProps = {
    hasPriceOrPercent,
    pricePercentNumber,
    isHalfPrice,
    isWhileStocksLast,
    isMoreThanHalfPrice,
    shouldShowPriceBadge,
    isLongPrice,
    variant,
    endDate,
    subText,
    hotDealHalfPriceText,
  };

  return (
    <div className={styles.container}>{isRedFlag ? <RedFlag {...badgeProps} /> : <Starburst {...badgeProps} />}</div>
  );
};
